import axios from 'axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const DEPENSERECETTE_URL = `${backendUrl}/api/depenserecette/`;

class DepenserecetteService {
	async getAllDepenserecettes() {
		try {
			const response = await axios.get(DEPENSERECETTE_URL);
			return response.data;
		} catch (error) {
			console.error('Erreur de connexion', error);
			throw error;
		}
	}

	getDepenserecette(id) {
		return axios.get(`${DEPENSERECETTE_URL}${id}/`);
	}

	createDepenserecette(data) {
		return axios.post(DEPENSERECETTE_URL, data).catch((error) => {
			console.error('Erreur lors de la création du depense', error);
			throw error;
		});
	}

	updateDepenserecette(id, data) {
		return axios.put(`${DEPENSERECETTE_URL}${id}/`, data);
	}

	deleteDepenserecette(id) {
		return axios.delete(`${DEPENSERECETTE_URL}${id}/`);
	}
}

export default new DepenserecetteService();
